module.exports = __webpack_public_path__ + "static/media/ariana-grande-sweetner-album-art-2018-billboard-1240@2x.7bde8b59.png";